import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import axios from "axios";
import PlaceholderTemplate from "../placeholders/PlaceholderTemplate";

class JoinTeam extends Component {
    state = {
        isJoining: false,
        joined: false,
        error: null
    };

    getTeam() {
        return this.props.match.params.team;
    }

    handleJoin = () => {
        this.setState({ isJoining: true, error: null });

        axios
            .post("/api/v1/teams/" + encodeURIComponent(this.getTeam()) + "/join", "", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            })
            .then(() => {
                this.setState({ isJoining: false, joined: true });
            })
            .catch(error => {
                const errorMessage =
                    (error.response && error.response.data && error.response.data.message) ||
                    "Failed to join the team. Please try again.";
                this.setState({ isJoining: false, error: errorMessage });
            });
    };

    renderJoined() {
        return (
            <PlaceholderTemplate
                header={"You joined '" + this.getTeam() + "' team"}
                leading={"You can now manage the games from the linked account."}
                body={
                    <div className="d-flex justify-content-center">
                        <Link className="button button--blue" to="/app/games">
                            Go to games
                        </Link>
                    </div>
                }
            />
        );
    }

    renderJoinForm() {
        const { isJoining, error } = this.state;

        return (
            <PlaceholderTemplate
                header={"Join '" + this.getTeam() + "' team"}
                leading={
                    "If you join the team, you will be able to manage the games from the linked account, but at the same time you will lose access to any games created on this account."
                }
                body={
                    <div>
                        {error && (
                            <div className="modal-dialog__error">
                                <i className="fas fa-times-circle" style={{ marginRight: "8px" }} />
                                {error}
                            </div>
                        )}
                        <div className="d-flex justify-content-center">
                            <button
                                className="button button--blue"
                                onClick={this.handleJoin}
                                disabled={isJoining}>
                                {isJoining ? (
                                    <span>
                                        <i
                                            className="fas fa-spinner fa-spin"
                                            style={{ marginRight: "6px" }}
                                        />
                                        Joining...
                                    </span>
                                ) : (
                                    "Join the team"
                                )}
                            </button>
                        </div>
                    </div>
                }
            />
        );
    }

    render() {
        return this.state.joined ? this.renderJoined() : this.renderJoinForm();
    }
}

JoinTeam.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            team: PropTypes.string.isRequired
        }).isRequired
    }).isRequired
};

export default JoinTeam;
